import {createSelector} from 'reselect';
import {getOrderSummary} from './selectors';

/**
 * Selector to get the first optional basket item with isSubscription set to true
 * @returns {Object|undefined} First subscription basket item or undefined if none exist
 */
export default createSelector(
  [getOrderSummary],
  orderSummary => {
    const optionalBasketItems = orderSummary?.optionalBasketItems || [];
    return optionalBasketItems.find(item => item.isSubscription === true);
  }
);